'use es6';

import * as client from 'DesignData/api/GlobalGroups';
import { GLOBAL_GROUPS_FETCH_FOR_WIDGETS } from 'DesignData/actions/ActionTypes';
/*
 * Gets all global groups for use as widgets.
 *
 * TODO: We need an API endpoint that just lists summary data.
 *
 * GET  designmanager/v1/layouts?template_type=18
 */

export function fetchForWidgets(query = {}) {
  const {
    request,
    receive,
    error
  } = fetchForWidgets;
  return dispatch => {
    dispatch(request());
    return client.fetchSummaries(query).then(widgets => {
      dispatch(receive(widgets));
    }).catch(err => {
      dispatch(error(err));
    });
  };
}

fetchForWidgets.request = function request() {
  return {
    type: GLOBAL_GROUPS_FETCH_FOR_WIDGETS
  };
};

fetchForWidgets.receive = function receive(widgets) {
  return {
    type: GLOBAL_GROUPS_FETCH_FOR_WIDGETS,
    widgets
  };
};

fetchForWidgets.error = function error(err) {
  return {
    type: GLOBAL_GROUPS_FETCH_FOR_WIDGETS,
    error: err
  };
};